<template>
  <a-result status="500"
            title="500"
            sub-title="页面错误">
    <template #extra>
      <a-button type="primary" @click="backHome">
        返回首页
      </a-button>
    </template>
  </a-result>

</template>

<script>
  export default {
    name: 'page500',
    data () {
      return {}
    },
    methods: {
      backHome () {
        this.$router.push('/')
      },
    },
  }
</script>

<style scoped>
</style>